<template>
  <el-dialog
    :title="'选择配件出库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <template>
      <div  style="height:400px; overflow:auto">
        <el-table
          :data="data"
          ref="table"
          highlight-current-row
          @selection-change="selectionChange"
          @current-change="handleCurrentChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            label="配件名称"
            prop="PartsName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="入场编号"
            prop="Source"
            width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="仓库名称"
            prop="WarehouseName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="Quantity"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="单位"
            prop="Unit"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="总重量" prop="Weight" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
        <el-pagination
          ref="breadCrumb"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="getTableData(1)"
          @current-change="getTableData()"
          :current-page.sync="pageIndex"
          :page-size.sync="pageSize"
          :total="pageTotal"
        ></el-pagination>
      
    </template>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >确认出库</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
import UploadPhoto from "@/components/UploadPhoto.vue";
export default {
  props: ["item"],
  components: {
    UploadPhoto,
  },
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      WarehouseId: "",
      PartsId: "",
      selectdata: [],
      EntyId: [],
      data: [],
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("AccessoryEntryRecords/GetOutAccessoryList", {
          WarehouseId: v.WarehouseId,
          PartsId: v.PartsId,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        }).then((r) => {
          let list = r.Result;
          let pageTotal = r.Rows;
          if (list.length > 0) {
            let row = list[0];
            this.$refs.table.setCurrentRow(row);
          }
          this.data = list;
          this.pageTotal = pageTotal;
        });
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.EntyId=[];
      this.selectdata.forEach((row) => {
        this.EntyId.push(row.EntryId);
      });
      let params = {};
      params.EntryId = this.EntyId;
      this.loading = true;
      this.$post("AccessoryEntryRecords/OutAccessoryStorage", {
        EntryId: this.EntyId,
      }).then((r) => {
        this.$message.success("添加成功");
        this.visible = false;
        this.$emit("success");
      });
      this.loading = false;
    },
    selectionChange(selection) {
      this.selectdata = selection;
    },
    handleCurrentChange(row) {
      this.$emit("currentrow", row);
    },
  },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>